// Colour names from https://www.color-blindness.com/color-name-hue/
export default {
  colors: {
    black: "#fef",
    text: "#fff",
    white: "#333",
    delta: "#67626d",
    smoke: "#252323",
    picton: "#7D7AA2",
    cerulean: "#5A819E",
    gondola: "#343434",
    salmon: "#FFC1A7",
    froly: "#F67E7D",
    sand: "#001a3b",
    tangerine: "#ffb717",
    cardinal: "#d42128",
    purple: "#6d1e6a",
    yellowGreen: "#005b34",
    racingGreen: "#bed63a",
    sapphire: "#072647",
    sinbad: "#9DCFC2",
    monteCarlo: "#6CC2BD",
    nero: "#d2d2d2",
    mortar: "#555555",
    glass: "hsla(207, 26%, 34%, 0.8)",
    fade: "rgba(255, 255, 255, 0.2)",
  }
};
